<template lang="pug">
.form-group
  label(v-if='fieldLabel') {{fieldLabel}}
    span(v-if='required') &nbsp*
      .helptip-wrapper
        span.helptip-icon(v-if='helptipBody' @click='toggleHelp()')
          i(:class='[showHelp ? hideIcon : showIcon]')
        ed-input-tooltip(:class='{"error-message": error}'
          v-if='helptipBody && showHelp || helptipBody && error'
          :helptipHeader='helptipHeader'
          :errorTip='error'
          :helptipBody='helptipBody'
        )
  label(:class='classObject' @mousedown='mousedown')
    span.vue-switcher__label(v-if='shouldShowLabel')
      span(v-if='label' v-text='label')
    input(type='checkbox' :disabled='disabled' @change='trigger' :checked='value')
    .dawn-switch-switch
      span.switch-text(v-if='!label && value' v-text='textEnabled')
      span.switch-text(v-if='!label && !value' v-text='textDisabled')
  span(v-if='value')
    slot
</template>

<script>

export default {
  name: 'ed-switch',
  props: {
    fieldLabel: String,
    required: Boolean,
    value: {
      default: false
    },
    disabled: {
      default: false
    },
    label: {
      default: ''
    },
    textEnabled: {
      default: 'On'
    },
    textDisabled: {
      default: 'Off'
    },
    color: {
      default: 'default'
    },
    emitOnMount: {
      default: true
    },
    helptipHeader: String,
    helptipBody: String,
    error: Boolean
  },

  mounted () {
    if (this.emitOnMount) {
      this.$emit('input', this.value)
    }
  },

  data () {
    return {
      showHelp: false,
      showIcon: 'fas fa-question-circle',
      hideIcon: 'far fa-times-circle'
    }
  },

  methods: {
    trigger (e) {
      this.$emit('input', e.target.checked)
    },
    mousedown (e) {
      this.$emit('mousedown', e)
    },
    toggleHelp () {
      this.showHelp = !this.showHelp
    }
  },

  computed: {
    classObject () {
      const { color, value, disabled } = this // eslint-disable-line
      return {
        'vue-switcher': true,
        'vue-switcher--unchecked': !value,
        'vue-switcher--disabled': disabled
      }
    },
    shouldShowLabel () {
      return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== ''
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.vue-switcher {
  position: relative;
  display: block;

  &__label {
    display: block;
    font-size: 10px;
    margin-bottom: 5px;
  }

  .switch-text {
    @include theme() { color: v(canvas) }
    text-transform: uppercase;
    text-shadow: $box-shadow;
    font-size: $font-size-xsmall;
  }

  input {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    cursor: pointer;
  }

  div.dawn-switch-switch {
    width: 3.5em;
    position: relative;
    border-radius: .2rem;
    display: -webkit-flex;
    display: -ms-flex;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: linear .2s, background-color linear .2s;
    padding: .2rem;

    &:after {
      content: '';
      height: .9rem;
      width: 1.2rem;
      display: block;
      transition: linear .15s, background-color linear .15s;
      position: absolute;
      top: .25rem;
      left: 100%;
      margin-left: -1.5rem;
      cursor: pointer;
      box-shadow: $box-shadow;
    }
  }

  &--unchecked {
    div.dawn-switch-switch {
      justify-content: flex-end;

      &:after {
        left: 1.7rem;
      }
    }
  }

  &--disabled {
    div.dawn-switch-switch {
      opacity: .3;
    }

    input {
      cursor: not-allowed;
    }
  }

  &--unchecked {
    div {
      &:after {
        right: 1.3rem;
      }
    }
  }

  .vue-switcher__label {
    span {
      padding-bottom: 7px;
      display: inline-block;
    }
  }

  div.dawn-switch-switch {
    @include theme() {
    background-image: linear-gradient(
                        darken(v(tertiary-01), 10%),
                               v(tertiary-01)
                      )
    }
    &:after {
      @include theme() { background-color: v(canvas) }
    }
  }

  &.vue-switcher--unchecked {
    div.dawn-switch-switch {
      @include theme() {
      background-image: linear-gradient(
                          darken(v(background), 10%),
                                 v(background)
                        )
      }
      &:after {
        @include theme() { background-color: v(canvas) }
      }
    }
  }

}

.helptip-icon {
  &:hover {
    cursor: pointer;
  }
}

.helptip-wrapper {
  display: inline-block;
  position: relative;
}

.dawn-input-tooltip {
  top: -110%;
  width: 2600%;
  left: 230%;
}
</style>



// WEBPACK FOOTER //
// src/core/components/edSwitch/index.vue